import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {NormalizadorService} from './normalizador.service';
import {DraftService} from './draft.service';
import {ShoppingCartService} from './shopping-cart-service';
import {ApiAmenaService} from './api-amena.service';

@Injectable({
    providedIn: 'root'
})
export class GeneralService {

    protected Stepper: any;
    protected FormularioNormalizacion: any;
    protected FormularioCobertura: any;
    protected FormularioMobilePack: any;
    protected FormularioUserData: any;
    protected FormularioUserBank: any;
    protected EmptyFormNormalizacion: any;
    protected EmptyFormCobertura: any;
    protected EmptyFormLandlineConfiguration: any;
    protected EmptyFormMobilePack: BehaviorSubject<any[]>;
    protected EmptyFormUserData: any;
    protected EmptyFormUserDataBank: any;
    protected EmptyFormTerminalDelivery: any;
    public saveDataUserInvalid: BehaviorSubject<boolean>;
    protected mobilePacks: any[];

    constructor(
        protected normalizadorService: NormalizadorService,
        protected draftService: DraftService,
        protected shoppingCartService: ShoppingCartService,
        protected amenaService: ApiAmenaService
    ) {
        this.FormularioNormalizacion = new BehaviorSubject<any>(null);
        this.FormularioCobertura = new BehaviorSubject<any>(null);
        this.FormularioMobilePack = new BehaviorSubject<any>(null);
        this.FormularioUserData = new BehaviorSubject<any>(null);
        this.FormularioUserBank = new BehaviorSubject<any>(null);
        this.EmptyFormNormalizacion = new BehaviorSubject<any>(null);
        this.EmptyFormCobertura = new BehaviorSubject<any>(null);
        this.EmptyFormLandlineConfiguration = new BehaviorSubject<any>(null);
        this.EmptyFormMobilePack = new BehaviorSubject([]);
        this.EmptyFormUserData = new BehaviorSubject<any>(null);
        this.EmptyFormUserDataBank = new BehaviorSubject<any>(null);
        this.EmptyFormTerminalDelivery = new BehaviorSubject<any>(null);
        this.saveDataUserInvalid = new BehaviorSubject<boolean>(false);

        this.mobilePacks = [];

        // Observadores que actualizan tanto el estado del borrador como del carrito, si sus formularios son validos
        this.normalizadorService.getFormularioNormalizacion()
            .subscribe(data => {
                this.draftService.updateOrder(data);
                this.shoppingCartService.updateCart(data);
            });

        this.normalizadorService.getResultadoCobertura()
            .subscribe(data => {
                this.setFormularioCobertura(data);
                this.draftService.updateOrder(data);
                this.shoppingCartService.updateCart(data);
            });

        this.getFormularioMobilePack()
            .subscribe(data => {
                if (data !== null) {
                    const datos = data.getRawValue();
                    if (data.status !== 'INVALID' || data.get('stepper_index').value > 1 ||
                       (datos.rate.type === 'mobile' && datos.stepper_index === 0)) {
                        this.draftService.updateOrder(data);
                        this.shoppingCartService.updateCart(data);
                    }
                }
            });

        this.getFormularioUserData()
            .subscribe(data => {
                if (data !== null) {
                    const auxData = data.getRawValue();
                    if (auxData.doc && auxData.doc !== '' && auxData.doctype && auxData.doctype !== '') {
                        this.draftService.updateOrder(data);
                        this.shoppingCartService.updateCart(data);
                    }
                }
            });

        this.getFormularioUserBank()
            .subscribe(data => {
                if (data !== null) {
                    if (data.status !== 'INVALID') {
                        this.draftService.updateOrder(data);
                        this.shoppingCartService.updateCart(data);
                    }
                }
            });
    }

    public getFormularioNormalizacion() {
        return this.FormularioNormalizacion.asObservable();
    }

    public setFormularioNormalizacion(value) {
        this.FormularioNormalizacion.next(value);
    }

    public getFormularioCobertura() {
        return this.FormularioCobertura.asObservable();
    }

    public setFormularioCobertura(value) {
        this.FormularioCobertura.next(value);
    }

    public getFormularioMobilePack() {
        return this.FormularioNormalizacion.asObservable();
    }

    public setFormularioMobilePack(value) {
        this.FormularioNormalizacion.next(value);
    }

    public getFormularioUserData() {
        return this.FormularioUserData.asObservable();
    }

    public setFormularioUserData(value) {
        this.FormularioUserData.next(value);
    }

    public getFormularioUserBank() {
        return this.FormularioUserBank.asObservable();
    }

    public setFormularioUserBank(value) {
        this.FormularioUserBank.next(value);
    }

    public getEmptyFormNormalizacion() {
        return this.EmptyFormNormalizacion.asObservable();
    }

    public setEmptyFormNormalizacion(value) {
        this.EmptyFormNormalizacion.next(value);
    }

    public getEmptyFormCobertura() {
        return this.EmptyFormCobertura.asObservable();
    }

    public setEmptyFormCobertura(value) {
        this.EmptyFormCobertura.next(value);
    }

    public getEmptyFormLandlineConfiguration() {
        return this.EmptyFormLandlineConfiguration.asObservable();
    }

    public setEmptyFormLandlineConfiguration(value) {
        this.EmptyFormLandlineConfiguration.next(value);
    }

    public getEmptyFormMobilePack() {
        return this.EmptyFormMobilePack.asObservable();
    }

    public setEmptyFormMobilePack(index, value) {
        if (typeof this.mobilePacks[index] === 'undefined') {
            this.mobilePacks.push(value);
        } else {
            this.mobilePacks[index] = value;
        }

        this.EmptyFormMobilePack.next(Object.assign({}, this.mobilePacks));
    }

    public setEmptyFormMobilePackAll(value) {
        this.mobilePacks = value;
        this.EmptyFormMobilePack.next(value);
    }

    public getEmptyFormUserData() {
        return this.EmptyFormUserData.asObservable();
    }

    public setEmptyFormUserData(value) {
        this.EmptyFormUserData.next(value);
    }

    public getEmptyFormUserDataBank() {
        return this.EmptyFormUserDataBank.asObservable();
    }

    public setEmptyFormUserDataBank(value) {
        this.EmptyFormUserDataBank.next(value);
    }

    public getEmptyFormTerminalDelivery() {
        return this.EmptyFormTerminalDelivery.asObservable();
    }

    public setEmptyFormTerminalDelivery(value) {
        this.EmptyFormTerminalDelivery.next(value);
    }

    public updateChanges(data) {
        this.draftService.updateOrder(data);
    }

    public saveDraft() {
        this.draftService.saveDraft();
    }

    public getSaveDataUserInvalid() {
        return this.saveDataUserInvalid.asObservable();
    }

    public setSaveDataUserInvalid(data) {
        this.saveDataUserInvalid.next(data);
    }

    public resetForms() {
        this.setFormularioNormalizacion(null);
        this.setFormularioCobertura(null);
        this.setFormularioMobilePack(null);
        this.setFormularioUserData(null);
        this.setFormularioUserBank(null);
    }

    public resetEmptyForms() {
        this.setEmptyFormNormalizacion(null);
        this.setEmptyFormCobertura(null);
        this.setEmptyFormLandlineConfiguration(null);
        this.setEmptyFormMobilePackAll(null);
        this.setEmptyFormUserData(null);
        this.setEmptyFormUserDataBank(null);
    }

}
